import { render, staticRenderFns } from "./ActorRoleUpdate.vue?vue&type=template&id=69950414&"
import script from "./ActorRoleUpdate.vue?vue&type=script&lang=js&"
export * from "./ActorRoleUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports